import React from 'react'
import cn from 'utils/tailwind/cn'

import { useFormAppearance } from '@/hooks/useFormAppearance'

/**
 * @deprecated
 */

function Radio({
  inputId,
  disabled,
  willShowNotAllowedCursor,
  onChange = () => {},
  checked,
  label,
  hasError,
  children,
  ...props
}) {
  const handleChange = disabled ? () => {} : (e) => onChange(e.target.checked)
  const { hasQuestionColor } = useFormAppearance()
  return (
    <label className="align-center mb-2 flex">
      <input
        checked={checked}
        className={cn('form-radio h-5 w-5 border text-blue-600', {
          'cursor-not-allowed bg-gray-100': willShowNotAllowedCursor,
          'cursor-pointer': !willShowNotAllowedCursor,
          'border-2 border-red-500': hasError,
        })}
        disabled={disabled}
        id={inputId}
        onChange={handleChange}
        type="radio"
        {...props}
      />
      <span
        className={cn(
          hasQuestionColor && 'question-text',
          'ml-2 text-left text-sm leading-5 text-gray-700'
        )}
      >
        {label || children}
      </span>
    </label>
  )
}

export default Radio
